export const acContentTile = '家长须知'
export const acContentText = `
<p align="center">&nbsp;免责条款</p>
<p>&nbsp;</p>
<p>因以下原因导致我们无法按照约定提供平台服务或未实现预期效果，我们将免于承担责任：</p>
<p><!-- [if !supportLists]-->1.&nbsp;<!--[endif]-->系统升级维护；</p>
<p><!-- [if !supportLists]-->2.&nbsp;<!--[endif]-->您提供的相关信息不真实、不准确、不完整或未及时更新；</p>
<p><!-- [if !supportLists]-->3.&nbsp;<!--[endif]-->您未按照规范使用或以未经我们授权或许可的方式使用平台服务；</p>
<p><!-- [if !supportLists]-->4.&nbsp;<!--[endif]-->您使用的设备软硬件或通信网络、电力线路出现故障；</p>
<p><!-- [if !supportLists]-->5.&nbsp;<!--[endif]-->平台程序被恶意攻击、木马、病毒、网络拥堵、系统瘫痪或不稳定、系统或相关设备故障、学校、教师、政府行为等第三方原因；</p>
<p><!-- [if !supportLists]-->6.&nbsp;<!--[endif]-->您使用的程序版本过时、您设备的老化，和/或其兼容性问题；</p>
<p><!-- [if !supportLists]-->7.&nbsp;<!--[endif]-->出现不可抗力事件或重大情势变更。</p>
<p>&nbsp;</p>
<p>尽管如此，我们在上述情况发生后仍会采取必要措施以尽早恢复服务、实现预期效果。</p>
<p>&nbsp;</p>
<p align="center">隐私保护政策概要</p>
<p align="center">&nbsp;</p>
<p>感谢您信任并使用智育心桥 ，</p>
<p>我们深知用户个人信息安全及个人隐私的重要性，为了在您使用本智育心桥时更好地保障您个人隐私及相关数据安全，我们特提请您注意如下事项：</p>
<p>1.为向您提供本平台的相关服务，我们会收集、使用、存储提供服务所必要的个人信息；</p>
<p>2.基于您的明示授权，我们可能会获取您的位置、设备号信息等信息，您有权拒绝或取消您的授权；</p>
<p>3.我们将采用业界先进的安全措施保护您的个人信息安全；</p>
<p>4.未经您同意，我们不会从第三方处获取、不会与第三方共享或向其提供您的个人信息；</p>
<p>5.您可以查询、补充、更正、删除您的个人信息。</p>
<p>6.如您对您的个人信息及隐私保护事宜有任何问题，或者投诉、意见或建议，您可以随时联系我们。</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
`